function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoordinateList from '../../geom/CoordinateList';
import Orientation from '../../algorithm/Orientation';
import Distance from '../../algorithm/Distance';
var BufferInputLineSimplifier = /*#__PURE__*/function () {
  function BufferInputLineSimplifier() {
    _classCallCheck(this, BufferInputLineSimplifier);
    BufferInputLineSimplifier.constructor_.apply(this, arguments);
  }
  return _createClass(BufferInputLineSimplifier, [{
    key: "isDeletable",
    value: function isDeletable(i0, i1, i2, distanceTol) {
      var p0 = this._inputLine[i0];
      var p1 = this._inputLine[i1];
      var p2 = this._inputLine[i2];
      if (!this.isConcave(p0, p1, p2)) return false;
      if (!this.isShallow(p0, p1, p2, distanceTol)) return false;
      return this.isShallowSampled(p0, p1, i0, i2, distanceTol);
    }
  }, {
    key: "deleteShallowConcavities",
    value: function deleteShallowConcavities() {
      var index = 1;
      var maxIndex = this._inputLine.length - 1;
      var midIndex = this.findNextNonDeletedIndex(index);
      var lastIndex = this.findNextNonDeletedIndex(midIndex);
      var isChanged = false;
      while (lastIndex < this._inputLine.length) {
        var isMiddleVertexDeleted = false;
        if (this.isDeletable(index, midIndex, lastIndex, this._distanceTol)) {
          this._isDeleted[midIndex] = BufferInputLineSimplifier.DELETE;
          isMiddleVertexDeleted = true;
          isChanged = true;
        }
        if (isMiddleVertexDeleted) index = lastIndex;else index = midIndex;
        midIndex = this.findNextNonDeletedIndex(index);
        lastIndex = this.findNextNonDeletedIndex(midIndex);
      }
      return isChanged;
    }
  }, {
    key: "isShallowConcavity",
    value: function isShallowConcavity(p0, p1, p2, distanceTol) {
      var orientation = Orientation.index(p0, p1, p2);
      var isAngleToSimplify = orientation === this._angleOrientation;
      if (!isAngleToSimplify) return false;
      var dist = Distance.pointToSegment(p1, p0, p2);
      return dist < distanceTol;
    }
  }, {
    key: "isShallowSampled",
    value: function isShallowSampled(p0, p2, i0, i2, distanceTol) {
      var inc = Math.trunc((i2 - i0) / BufferInputLineSimplifier.NUM_PTS_TO_CHECK);
      if (inc <= 0) inc = 1;
      for (var i = i0; i < i2; i += inc) {
        if (!this.isShallow(p0, p2, this._inputLine[i], distanceTol)) return false;
      }
      return true;
    }
  }, {
    key: "isConcave",
    value: function isConcave(p0, p1, p2) {
      var orientation = Orientation.index(p0, p1, p2);
      var isConcave = orientation === this._angleOrientation;
      return isConcave;
    }
  }, {
    key: "simplify",
    value: function simplify(distanceTol) {
      this._distanceTol = Math.abs(distanceTol);
      if (distanceTol < 0) this._angleOrientation = Orientation.CLOCKWISE;
      this._isDeleted = new Array(this._inputLine.length).fill(null);
      var isChanged = false;
      do {
        isChanged = this.deleteShallowConcavities();
      } while (isChanged);
      return this.collapseLine();
    }
  }, {
    key: "findNextNonDeletedIndex",
    value: function findNextNonDeletedIndex(index) {
      var next = index + 1;
      while (next < this._inputLine.length && this._isDeleted[next] === BufferInputLineSimplifier.DELETE) next++;
      return next;
    }
  }, {
    key: "isShallow",
    value: function isShallow(p0, p1, p2, distanceTol) {
      var dist = Distance.pointToSegment(p1, p0, p2);
      return dist < distanceTol;
    }
  }, {
    key: "collapseLine",
    value: function collapseLine() {
      var coordList = new CoordinateList();
      for (var i = 0; i < this._inputLine.length; i++) {
        if (this._isDeleted[i] !== BufferInputLineSimplifier.DELETE) coordList.add(this._inputLine[i]);
      }
      return coordList.toCoordinateArray();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BufferInputLineSimplifier;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "simplify",
    value: function simplify(inputLine, distanceTol) {
      var simp = new BufferInputLineSimplifier(inputLine);
      return simp.simplify(distanceTol);
    }
  }]);
}();
export { BufferInputLineSimplifier as default };
BufferInputLineSimplifier.constructor_ = function () {
  this._inputLine = null;
  this._distanceTol = null;
  this._isDeleted = null;
  this._angleOrientation = Orientation.COUNTERCLOCKWISE;
  var inputLine = arguments[0];
  this._inputLine = inputLine;
};
BufferInputLineSimplifier.INIT = 0;
BufferInputLineSimplifier.DELETE = 1;
BufferInputLineSimplifier.KEEP = 1;
BufferInputLineSimplifier.NUM_PTS_TO_CHECK = 10;